import { normalizeInternalRedirect } from './authRedirect';

const BILLING_INTENT_KEY = 'postAuthIntent';
const BILLING_INTENT_TTL_MS = 30 * 60 * 1000;

function normalizeBillingIntent(value) {
  if (!value || !['checkout', 'manageBilling'].includes(value.intent)) return null;
  if (value.intent === 'checkout' && !value.planCode) return null;
  if (
    value.createdAt &&
    Date.now() - Number(value.createdAt) > BILLING_INTENT_TTL_MS
  ) return null;

  return {
    from: normalizeInternalRedirect(value.from) || '/pricing',
    intent: value.intent,
    ...(value.intent === 'checkout'
      ? {
          planCode: String(value.planCode),
          quantity: value.quantity ?? null,
        }
      : {}),
  };
}

export function readBillingIntent(routeState) {
  const routedIntent = normalizeBillingIntent(routeState);
  if (routedIntent) return routedIntent;

  try {
    const stored = JSON.parse(sessionStorage.getItem(BILLING_INTENT_KEY));
    if (!stored?.createdAt) return null;
    const intent = normalizeBillingIntent(stored);
    if (!intent) clearBillingIntent();
    return intent;
  } catch {
    clearBillingIntent();
    return null;
  }
}

export function storeBillingIntent(value) {
  const intent = normalizeBillingIntent(value);
  if (!intent) return null;
  try {
    sessionStorage.setItem(BILLING_INTENT_KEY, JSON.stringify({
      ...intent,
      createdAt: Date.now(),
    }));
  } catch {}
  return intent;
}

export function clearBillingIntent() {
  try {
    sessionStorage.removeItem(BILLING_INTENT_KEY);
  } catch {}
}
